import { axiosConfigNew as axios } from "../../../utils/axios";
import { axiosConfigOld as axiosOld } from "../../../utils/axios";

let url = '/graphql/main'

export const apiModules = (body: any) => axios.get(`/edu/theoretic-journal-print/module-dates`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year
  },
});

export const apiModuleEdit = (body: any) => axios.put(`/edu/theoretic-journal-print/save-module-dates`, body);


export const apiDeleteMedical = (id: any) => axios.delete(`/edu/theoretic-journal-print/delete-medical-result`, {
  params: {
    id
  },
});

export const apiStudy = (body: any) => axios.get(`/edu/theoretic-journal-print/students-info`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    side: body.side,
  },
});

export const apiStudyEdit = (body: any) => axios.patch(`/edu/theoretic-journal-print/save-students-info`, body);

export const apiMedical = (body: any) => axios.get(`/edu/theoretic-journal-print/medical-results`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    side: body.side,
  },
});
export const apiAppear = (params: any) => axios.get(`/medical-cabinet/appeals`, {
  params: params
});
// https://api-college.citorleu.kz/api/medical-cabinet/students-by-group
export const apiStudentsByGroup = (params: any) => axios.get(`/medical-cabinet/students-by-group`, {
  params: params
});

export const apiAppealEditOrPost = (body: any) => {
  if (body?.id) {
    return axios.put(`/medical-cabinet/appeals/${body?.id}`, body);
  }
  return axios.post(`/medical-cabinet/appeals`, body);
}

export const apiAppealDelete = (id: any) => axios.delete(`/medical-cabinet/appeals/${id}`);

export const apiAppealByID = (params: any) => axios.get(`/medical-cabinet/appeals/${params}`);


export const apiMedicalGroup = (body: any) => axios.get(`/edu/theoretic-journal-print/medical-groups`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    side: body.side,
  },
});

export const apiMedicalEdit = (body: any) => axios.put(`/edu/theoretic-journal-print/save-medical-result`, body);

export const apiRemark = (body: any) => axios.get(`/remark`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    ctp_type: body.ctp_type,
    teacher_id: body.teacher_id,
    teacher: body.teacher,
  },
});

export const apiSetRemark = (body: any) => axios.post(`/remark`, {
  group_id: body.group_id,
  year: body.year,
  remark_date: body.remark_date,
  remark_text: body.remark_text,
  ctp_type: body.ctp_type,
  teacher_id: body.teacher_id,
  teacher: body.teacher,

});

export const apiEditRemark = (body: any) => axios.patch(`/remark/${body.remark_id}`, body);

export const apiDeleteRemark = (id: any) => axios.delete(`/remark/${id}`);

export const apiTotalUvr = (body: any) => axios.get(`/edu/theoretic-journal-print/education-work-result`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    subject_id: body.subject_id,
    side: body.side,
  },
});

export const apiDisciplinesTotalUvr = (body: any) => axios.get(`/edu/theoretic-journal-print/subjects-list`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
  },
});

export const apiPrintJournalParams = ({ body, url }: any) => axios.get(`/edu/${url}-journal-print/print-params`);

export const apiPrintJournalSubjectList = ({ body, url }: any) => axios.get(`/edu/${url}-journal-print/subjects-list`, {
  params: {
    course: body.course,
    group: body.group,
    academic_year: body.year,
    teacher_id: body.teacher_id,
  },
});

export const apiPrintJournal = ({ body, url }: any) => axios.get(`/edu/${url}-journal-print/print`, {
  params: body,
  paramsSerializer: {
    indexes: true
  }
});


export const getGroupsApi = (body: any) => axiosOld.post(url, {
  query: `
    {
        groupsWithStudentsByCourse(year: ${body?.year}, course: ${body?.course}){
          id
          caption
      }
    }
  `
})


export const apiGetPrintTeachers = (params: any) => axios.get(`/edu/individual-journal-print/teachers`, {
  params: params
});